import { FC } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'
// eslint-disable-next-line import/no-extraneous-dependencies
import { RouteProps } from 'react-router'

import { selectIsAuth } from '@src/store/ducks/auth/selectors'
import { selectUserInfo } from '@src/store/ducks/user/selectors'
import { Error404 } from '@src/pages/Errors/Error404'

type PrivateRouteProps = {
  isNotSubscriber?: boolean
} & RouteProps

export const PrivateRoute: FC<PrivateRouteProps> = ({ isNotSubscriber, ...rest }) => {
  const isAuth = useSelector(selectIsAuth)
  const user = useSelector(selectUserInfo)

  if (!isAuth) return <Redirect to={{ pathname: '/login' }} />

  if (isNotSubscriber && user.isSubscriber) return <Error404 />

  return (
    <Route
      {...rest}
    />
  )
}
